import UpdatesList from "./UpdatesList";
export default UpdatesList;
